import styled from "@emotion/styled";
import myThemes from "../../common/themes/Themes";
import { StaticDatePicker } from "@mui/x-date-pickers";

export const StyledTitle = styled("div")(({ fireAnimation, theme }) => ({
  position: "fixed",
  zIndex: 1,
  transition: "height 0.3s ease",
  height: !fireAnimation ? "170px" : "3px",
  width: "100%",
  background: myThemes[theme].palette.primary,
  fontFamily: "Inter",
  marginBottom: "2vh",
  paddingLeft: "20vh",
  paddingRight: "20vh",
  paddingTop: "3vh",
  paddingBottom: "3vh",
  display: "flex",
  flexDirection: fireAnimation ? "row" : "column",
  alignItems: fireAnimation ? "center" : "flex-start",
  justifyContent: fireAnimation ? "flex-start" : "center",
}));

export const StyledInfo = styled("div")(({ fireAnimation, theme }) => ({
  backgroundColor: myThemes[theme].palette.secondary,
  padding: "15px",
  borderRadius: "20px",
  display: !fireAnimation ? "inline" : "none",
}));

export const SmallStyledInfo = styled("div")(({ fireAnimation, theme }) => ({
  borderRadius: "20px",
  padding: "8px",
  marginLeft: "15px",
  display: !fireAnimation ? "none" : "inline",
  backgroundColor: myThemes[theme].palette.secondary,
  color: myThemes[theme].palette.primary,
  fontSize: "30px",
}));

export const StyledScheduleContainer = styled("div")(() => ({
  display: "flex",
  flexDirection: "row",
}));

export const StyledTimeSlotsContainer = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
}));

export const StyledScheduleItem = styled("div")(() => ({
  order: 0,
  paddingRight: "30px",
  display: "flex",
  flexDirection: "column",
}));

export const StyledSlot = styled("div")(({ theme }) => ({
  width: "100%",
  padding: "10px",
  borderRadius: "10px",
  marginRight: "10px",
}));

export const StyledMMDD = styled("div")(({ theme }) => ({
  color: "#2E133A",
  fontSize: "20px",
  fontWeight: "700",
  fontFamily: "Inter",
  marginBottom: "10px",
  marginTop: "5px",
}));

export const StyledDay = styled("div")(({ theme }) => ({
  color: "white",
  fontSize: "11px",
  fontWeight: "700",
  fontFamily: "Inter",
  backgroundColor: "#2E133A",
  display: "inline",
  borderRadius: "4px",
  padding: "3px",
}));

export const StyledTime = styled("div")(({ theme }) => ({
  display: "inline",
  backgroundColor: "#EBE8FC",
  color: "#2E133A",
  fontWeight: "700",
  fontFamily: "Inter",
  fontSize: "12.6px",
  padding: "6px",
  paddingLeft: "8px",
  borderRadius: "4px",
  marginBottom: "7px",
  marginRight: "7px",
  "&:hover": {
    boxShadow: "0 0 0 3px #AA78F7",
  },
}));

export const StyledDatePicker = styled(StaticDatePicker)(() => ({
  "& .MuiPickersDay-root": {
    backgroundColor: "white",
    borderRadius: "7px",
    fontFamily: "Inter !important",
    fontWeight: "700",
  },

  "& .MuiPickersDay-root: hover": {
    backgroundColor: "#EBE8FC !important",
    color: "#2E133A",
  },

  "& MuiPickersDay-today": {
    backgroundColor: "#2E133A !important",

    color: "#2E133A !important",
  },
  "& .MuiCalendarOrClockPicker-root": {
    backgroundColor: "white !important",
    borderRadius: "10px",
    marginTop: "5px",
    width: "390px",
    padding: 0,
  },
  "& .MuiPickersCalendarHeader-label": {
    fontFamily: "Inter !important",
    fontWeight: "700",
  },

  "& .Mui-selected": {
    fontFamily: "Inter !important",
    fontWeight: "700",
    color: "white",
    backgroundColor: "#2E133A !important",
  },
  "& .PrivatePickersYear-yearButton ": {
    fontFamily: "Inter !important",
    fontWeight: "700",
  },

  "& .css-3eghsz-PrivatePickersYear-button :hover": {
    backgroundColor: "#EBE8FC !important",
    color: "#2E133A",
  },
}));
